/*
 * File: /src/store/modules/callStatus.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import VoiceServices from 'src/services/voiceServices';

const state = {
  callStatus: undefined
};

const getters = {
  getCallStatus: state => {
    return state.callStatus;
  },
};
const actions = {
  async fetchCallStatus({ commit, state, rootGetters }) {
    if (state.callStatus == undefined) {
      const res = await VoiceServices.fetchCallStatus();
      commit('setCallStatus', res.data);
    }
  },
  unloadCallStatus({ commit }) {
    commit('setCallStatus', undefined);
  },
};
const mutations = {
  setCallStatus(state, callStatus) {
    state.callStatus = callStatus;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
